import React, { lazy } from 'react'
import Loadable from '../../components/Loadable/Loadable'
import { Page } from '../../Pages'

const ProfilePage = Loadable(lazy(() => import('./Profile')))

const profileRoutes = [
	{
		path: Page.profile.path,
		element: <ProfilePage />
	}
]

export default profileRoutes
